exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-0ffb089c] {\n  color: #d23131;\n}", ""]);

// exports
